(function () {
  'use strict';

  console.log('[pdp-linked-swatches] script loaded');

  var pendingFetch = null;

  function getSectionId() {
    var el = document.querySelector('[data-wetheme-section-type="template--product"][data-wetheme-section-id]');
    if (!el) { console.warn('[pdp-linked-swatches] no product section element found'); return null; }
    return el.dataset.wethemeSectionId;
  }

  function sortSwatches() {
    var wrapper = document.querySelector('.pdp-linked-products-swatch .swatch-items-wrapper');
    if (!wrapper) return;
    var items = Array.from(wrapper.querySelectorAll('.swatch-element'));
    items.sort(function (a, b) {
      var aLabel = (a.querySelector('a') || {getAttribute: function(){return '';}}).getAttribute('aria-label') || '';
      var bLabel = (b.querySelector('a') || {getAttribute: function(){return '';}}).getAttribute('aria-label') || '';
      return aLabel.localeCompare(bLabel);
    });
    items.forEach(function (el) { wrapper.appendChild(el); });
  }

  function swapSections(doc) {
    var newMedia = doc.querySelector('[data-product-media-wrapper]');
    var curMedia = document.querySelector('[data-product-media-wrapper]');
    console.log('[pdp-linked-swatches] media swap:', !!newMedia, !!curMedia);
    if (newMedia && curMedia) curMedia.replaceWith(newMedia);

    var swapped = 0;
    doc.querySelectorAll('[data-update-id]').forEach(function (newEl) {
      var id = newEl.dataset.updateId;
      var curEl = document.querySelector('[data-update-id="' + id + '"]');
      if (curEl) { curEl.replaceWith(newEl); swapped++; }
    });
    console.log('[pdp-linked-swatches] update-id blocks swapped:', swapped);
  }

  function handleSwatchClick(e) {
    var link = e.target.closest('a.pdp-linked-swatch__link');
    if (!link) return;

    if (link.getAttribute('aria-current') === 'page') {
      e.preventDefault();
      return;
    }

    var href = link.getAttribute('href');
    if (!href) return;

    var sectionId = getSectionId();
    if (!sectionId) return;

    e.preventDefault();
    console.log('[pdp-linked-swatches] fetching', href, 'section', sectionId);

    document.querySelectorAll('.pdp-linked-products-swatch .swatch-element').forEach(function (el) {
      el.classList.remove('active');
    });
    link.closest('.swatch-element').classList.add('active');

    if (pendingFetch) pendingFetch.abort();
    var controller = new AbortController();
    pendingFetch = controller;

    fetch(href + '?section_id=' + encodeURIComponent(sectionId), { signal: controller.signal })
      .then(function (res) {
        console.log('[pdp-linked-swatches] fetch status:', res.status, 'length hint:', res.headers.get('content-length'));
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        console.log('[pdp-linked-swatches] html length:', html.length);
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        swapSections(doc);
        sortSwatches();
        history.pushState({ pdpLinked: href }, '', href);
      })
      .catch(function (err) {
        if (err.name === 'AbortError') return;
        console.error('[pdp-linked-swatches] error:', err);
        window.location.href = href;
      });
  }

  document.addEventListener('click', handleSwatchClick);
  sortSwatches();

  window.addEventListener('popstate', function () {
    window.location.reload();
  });
})();
